import { useParams } from 'react-router-dom'
import { sellDeliveryNoteRefundStatusInversed } from '@teinor/erp/types/company/order/sell/sellDeliveryNoteRefund'
import SellDeliveryNoteRefundFinishedStep from './Steps/SellDeliveryNoteRefundFinishedStep'
import { TableComponentProps } from '../../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { InputTableURLsTable } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import useOrderScreenLogic from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/useOrderScreenLogic'


interface SingleSellDeliveryNoteRefundProps extends TableComponentProps { }

const SingleSellDeliveryNoteRefund: React.FC<SingleSellDeliveryNoteRefundProps> = ({ userPermissions }) => {
    const params = useParams<{ id: string }>()
    const OrderId = params.id

    const inputTableURLs: InputTableURLsTable = {
        createData: ['', {}],
        getData: ['/api/app/order/sell/sellDeliveryNoteRefund/getSellDeliveryNoteRefundComplete', { id: OrderId }],
        updateData: '',
        delete: '',
        updateHeaderData: '/api/app/order/sell/sellDeliveryNoteRefund/updateSellDeliveryNoteRefund',
        getSubProducts: ['', ['CustomerId']],
        updateOrderLines: '',
        printTags: ''
    }
    const { completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, headerChanges } = useOrderScreenLogic({ inputTableURLs, userPermissions: 'sell.refundDeliveryNote' })
    const status = parseInt(completeData?.header.status)
    if (status === sellDeliveryNoteRefundStatusInversed['accepted']) {
        return <SellDeliveryNoteRefundFinishedStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    }
    return null
}

export default SingleSellDeliveryNoteRefund